module.exports = __webpack_public_path__ + "img/116825.c9b6a8bb.svg";